import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle2, Building2, ArrowRight, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SignupSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const subscriptionId = searchParams.get('sub');
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (subscriptionId) {
      fetchSubscription();
    } else {
      setLoading(false);
    }
  }, [subscriptionId]);

  const fetchSubscription = async () => {
    try {
      const response = await fetch(`${API_URL}/api/subscriptions/status/${subscriptionId}`);
      if (response.ok) {
        const data = await response.json();
        setSubscription(data);
      }
    } catch (error) {
      console.error('Error fetching subscription:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900 flex items-center justify-center p-6">
      <Card className="max-w-md w-full bg-white/10 backdrop-blur border-white/20">
        <CardContent className="pt-8 pb-8 text-center">
          {loading ? (
            <Loader2 className="w-12 h-12 text-emerald-400 animate-spin mx-auto" />
          ) : (
            <>
              <div className="w-20 h-20 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle2 className="w-10 h-10 text-emerald-400" />
              </div>
              
              <h1 className="text-3xl font-bold text-white mb-2">
                Welcome to BodyCorp365!
              </h1>
              
              <p className="text-slate-300 mb-6">
                Your subscription has been confirmed.
                {subscription && (
                  <span className="block mt-2 text-emerald-400">
                    {subscription.building_name} - {subscription.unit_count} units
                  </span>
                )}
              </p>

              <div className="space-y-3">
                <Button 
                  className="w-full bg-emerald-500 hover:bg-emerald-600"
                  onClick={() => navigate('/login')}
                >
                  Log In to Your Dashboard
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
                
                <p className="text-sm text-slate-400">
                  A confirmation email has been sent to your inbox
                </p>
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
